import { useState } from 'react';
import { getHotSearch } from '@/api/search';

export const useHotSearch = () => {
  const [hotsearchCompanyList, setHotsearchCompanyList] = useState([]);

  const getCompanyList = async (keyword: string) => {
    if (keyword.length > 0) {
      try {
        const companies = await getHotSearch(keyword);
        if (companies?.status === 200) {
          setHotsearchCompanyList(companies?.data);
        }
      } catch (e) {
        console.log('Error', e);
      }
    }
  };

  return { hotsearchCompanyList, getCompanyList };
};
